const BaseView = require('./view');

module.exports = BaseView.extend({
  applyElementEvent: function (event) {
    const $thumbnail = $(event.currentTarget).closest('.thumbnail');

    this.trigger('apply', {
      thumbnail: $thumbnail.data('thumb'),
      source: $thumbnail.data('source')
    });
  },

  removeElementEvent: function (event) {
    const source = $(event.currentTarget).closest('.thumbnail').data('source');
    this.data = _(this.data).filter(function (video) {
      return video.source !== source;
    });

    this.render();
    this.trigger('change', this.getData());
    event.stopPropagation();
  },

  filterInvalidData: function (filteringData) {
    return filteringData.filter(data => data.source || data.file);
  }
});
